import truncate from 'lodash/truncate';

import { connect } from 'react-redux';

import NumericalComponent from './Component';

import {
  getSelectedSample,
  getSelectedSampleSummary,
  getOriginalSampleSummary
} from 'store/scenes/bootstrapCIs/samples';

import {
  getPrimaryParameterName,
  getPrimaryParameterValues
} from 'store/scenes/bootstrapCIs/primaryParameter/selectors';

const mapStateToProps = state => {
  const parameterName = getPrimaryParameterName(state);

  return ({
    parameterName: truncate(parameterName, { length: 15 }),

    randomSampleValues: getSelectedSample(state),
    randomSampleSummary: getSelectedSampleSummary(state),

    originalSampleValues: getPrimaryParameterValues(state),
    originalSampleSummary: getOriginalSampleSummary(state)
  });
};

export default connect(mapStateToProps)(NumericalComponent);
